"use strict";

Object.defineProperty(exports, "__esModule", {
            value: true
});

exports.default = function (fn) {
            var defer = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function () {
                        return setTimeout(fn, 0);
            };

            return defer(fn);
};

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-input-mask/lib/utils/defer.js
 ** module id = 501
 ** module chunks = 0
 **/